// initialize all components on page
Templating.initVueComponents();
Component.initComponents(); // dispatches "initialized" event

// scroll form into view after submit
new ScrollToFormNotification('[data-form-anchor]');
